// extracted by mini-css-extract-plugin
export default {"status":"status_status__tWFqY","sm":"status_sm__e+evJ","xs":"status_xs__zAhGZ"};